export interface ImageResolution {
  width: number;
  height: number;
}

export default function getImageResolution(imageSrc: string): Promise<ImageResolution> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.addEventListener('load', () => {
      const width = image.width || image.naturalWidth;
      const height = image.height || image.naturalHeight;

      resolve({
        width,
        height,
      });
    });
    image.addEventListener('error', (event) => {
      reject(event.error);
    });
  });
}
